import { FunctionComponent } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/pro-regular-svg-icons';
import clsx from 'clsx';
import NodeMenu from './NodeMenu';
import styles from './BaseStepNode.module.scss';

const DelayNode: FunctionComponent<NodeProps> = ({ data, selected }) => {
    const d = data as { label: string; subtitle: string; onRemove?: () => void };

    return (
        <>
            <Handle
                type="target"
                position={Position.Top}
                style={{ opacity: 0, pointerEvents: 'none' }}
            />
            <div className={clsx(styles.node, { [styles.selected]: selected })}>
                <div className={clsx(styles.iconCircle, styles.light)}>
                    <FontAwesomeIcon icon={faClock} />
                </div>
                <div className={styles.content}>
                    <span className={styles.title}>{d.label}</span>
                    {d.subtitle && <span className={styles.subtitle}>{d.subtitle}</span>}
                </div>
                {d.onRemove && <NodeMenu onDelete={d.onRemove} />}
            </div>
            <Handle
                type="source"
                position={Position.Bottom}
                style={{ opacity: 0, pointerEvents: 'none' }}
            />
        </>
    );
};

export default DelayNode;
